const TECHS = [
  "WordPress",
  "Cloudflare",
  "Google Analytics",
  "Search Console",
  "Rank Math",
  "LiteSpeed",
  "OpenAI",
  "Gemini",
  "Copilot",
  "Meta",
  "Google Business",
];

export default function Technologies() {
  // Duplicate for seamless marquee
  const items = [...TECHS, ...TECHS];
  return (
    <section
      data-testid="tech-cloud"
      className="py-16 md:py-20 border-y border-white/5 bg-white/[0.015] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8">
        <div className="text-center">
          <div className="text-xs uppercase tracking-widest text-white/40 font-semibold">
            Tools, Platforms &amp; Engines We Master
          </div>
        </div>
      </div>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050505] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050505] to-transparent z-10 pointer-events-none" />
        <div className="flex w-max animate-marquee">
          {items.map((t, i) => (
            <div
              key={`${t}-${i}`}
              data-testid={`tech-logo-${i}`}
              className="shrink-0 px-8 py-3 mx-3 rounded-full border border-white/10 bg-white/[0.02] text-white/60 font-display font-semibold text-lg tracking-wide hover:text-cyan-400 hover:border-cyan-500/30 transition-colors"
            >
              {t}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
